import { Component, inject, OnInit, signal } from '@angular/core';
import moment, { Moment } from 'moment/min/moment-with-locales';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScheduleEvent, ScheduleViewModel } from '../../../shared/models/ScheduleModels';
import { ScheduleService } from '../../../shared/services/schedule.service';

import { MaterialModule } from '../../../material/material.module';
import { Globals } from '../../../shared/models/globals';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ScheduleMenuComponent } from "../../components/schedule-menu/schedule-menu.component";
import { ScheduleMonthComponent } from '../schedule-month/schedule-month.component';
import { ScheduleWeekComponent } from '../schedule-week/schedule-week.component';
import { ScheduleComingComponent } from '../schedule-coming/schedule-coming.component';
import { MatLabel } from '@angular/material/input';

@Component({
    selector: 'app-schedule-view',
  imports: [MaterialModule, TranslateModule, RouterModule],
    templateUrl: './schedule-view.component.html',
    styleUrls: ['./schedule-view.component.css']
})
export class ScheduleViewComponent implements OnInit {

  route = inject(ActivatedRoute);
  Days: Array<Date> = [];
  WeekIndex: Array<number> = [];
  DayActive: Array<boolean> = [];
  DayClass: Array<string> = [];
  daysOfMonth = [];
  schedule: ScheduleViewModel;
  currentYear: number;
  currentMonth: number;
  currentDate: number;
  currentMonthText: string="";
  selectDateText = signal("");
  isLoading: boolean = false;
  currentTz: string;
  selectedDate = moment();
  selectedView: string = 'month'; // Default to month view


  constructor(private scheduleService: ScheduleService, 
    public _router: Router, 
    private _globals: Globals, 
    private translate: TranslateService,
    private _snackBar: MatSnackBar) 
  {

    moment.locale(this._globals.selectedLocale);

  }

  ngOnInit() {

    //moment.locale('sv');
    var now = new Date();
    this.currentYear = now.getFullYear();
    this.currentMonth = now.getMonth();
    var m =  moment().set({'year': this.currentYear, 'month': this.currentMonth, 'date': 1});//.add(1, 'months');
    this.selectDateText.set(m.format('MMMM'));

    // The default empty-path child route ('') already mounts
    // ScheduleMonthSmallComponent, so just set the active view here.
    // Calling setMode() (which router-navigates to the 'month-small' path)
    // would destroy that initial instance and create a second one,
    // triggering getScheduleData() — and the API call — twice.
    this.selectedView = "month-small";

    // Child components handle their own data loading
    // this.getScheduleData();
    this.setDateText(m);


  }

  setMode(newMode: string) {
    this._router.navigate([{ outlets: { schedule: [newMode] } }], { relativeTo: this.route, queryParams: { selectedDate: this.selectedDate.format('YYYY-MM-DD') } });
    this.selectedView = newMode;
    this.setDateText(this.selectedDate);
  }

  getScheduleData(){
    this.isLoading=true;
    //console.log(this.currentYear + '-' + (this.currentMonth+1));
    this.scheduleService.getSchedule(this.currentYear, this.currentMonth+1).subscribe(data=>{
        this.schedule = data;
        //console.log('hej');
        let a = moment(data.StartDateForMonthView);
        let b = moment(data.EndDateForMonthView);
        let tempDate = a;
        let daysCount = b.diff(a, 'days');
        this.Days = [];
        this.DayClass = [];
     
        //console.log('*dayscount' + daysCount);
        for(let i= 0;i<=daysCount ;i++){
          
          this.Days.push(tempDate.toDate());  

          var tmpClass ="calendar-day ";
          if(tempDate<moment(data.StartDateForMonth)|| tempDate>moment(data.EndDateForMonth)){
            tmpClass +=" calendar-day-outofrange ";
          }
          if(tempDate.isSame(moment().toDate())){
            tmpClass +=" calendar-day-today ";
          }
          //console.log(tempDate);
          //console.log(moment().toDate());
          
          this.DayClass.push(tmpClass);
          
          
          tempDate =tempDate.add(1, 'day');
          
        }

        //console.log(this.schedule.EventList);
        this.isLoading=false;

    });
  }

  getEvents(day: Date):Array<ScheduleEvent>{
    /* console.log(this.schedule.EventList.filter( event=>{
      return moment(event.EventStart).isSame(moment(day), 'day');
    })); */

    return this.schedule.EventList.filter( event=>{
      return moment(event.EventStart).isSame(moment(day),'day');
    });
  }

  
  openGameDetails(GameId: string){
    this._router.navigate(['/schedule/gamedetails', GameId]);
    
  }

  deleteEventFromCalendar(EventId: string){
    //console.log(EventId);    
    this.scheduleService.removeEventFromSchedule(EventId).subscribe(res=>{
      //console.log(res);
      this.openSnackBar("EVENT REMOVED", "CLOSE");
      this.getScheduleData();
    });

  }

  setDateText(theDate: Moment) {
    if (this.selectedView === 'month' || this.selectedView === 'month-small') {
      this.selectDateText.set(theDate.format('yyyy MMMM'));
    } else if (this.selectedView === 'week') {
      this.selectDateText.set(theDate.format('YYYY-MM-DD'));
    }
  }

  next() {
    var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': this.currentDate });
    var startDate = moment()
    if (this.selectedView === 'month' || this.selectedView === 'month-small') {
      m.add(1, 'months');
      startDate = m.clone().startOf('month');
      //console.log("month view selected: " + this.selectDateText);
    }
    else if (this.selectedView === 'week') {
      m.add(7, 'days');
      startDate = m.clone().weekday(1);
      //console.log("week view selected: " + this.selectDateText);
    }
    this.setDateText(startDate);

    //console.log(this.selectDateText);

    this._router.navigate([{ outlets: { schedule: [this.selectedView] } }], { relativeTo: this.route, queryParams: { selectedDate: startDate.format('yyyy-MM-DD') } });



    //console.log(m.format('MMMM'));
    this.currentYear = startDate.year();
    this.currentMonth = startDate.month();
    this.currentDate = startDate.date();
    this.selectedDate = startDate;




  }

  previous() {
    var m = moment().set({ 'year': this.currentYear, 'month': this.currentMonth, 'date': this.currentDate });
    var startDate = moment()
    if (this.selectedView === 'month' || this.selectedView === 'month-small') {

      m.add(-1, 'months');
      startDate = m.clone().startOf('month');

      //console.log("month view selected: " + this.selectDateText);
    }
    else if (this.selectedView === 'week') {
      m.add(-7, 'days');
      startDate = m.clone().weekday(1);

      //console.log("week view selected: " + this.selectDateText);
    }
    this.setDateText(startDate);



    //console.log(m.format('MMMM'));
    this.currentYear = startDate.year();
    this.currentMonth = startDate.month();
    this.currentDate = startDate.date();
    this.selectedDate = startDate;

    this._router.navigate([{ outlets: { schedule: [this.selectedView] } }], { relativeTo: this.route, queryParams: { selectedDate: startDate.format('yyyy-MM-DD') } });

    //this.currentMonthText = m.format('MMMM');


  }

  setToday() {
    var m = moment();
    this.currentYear = m.year();
    this.currentMonth = m.month();
    this.currentDate = m.date();
    this.selectedDate = m;
    var startDate = moment()
    if (this.selectedView === 'month' || this.selectedView === 'month-small') {

      //m.add(-1, 'months');
      startDate = m.clone().startOf('month');

      //console.log("month view selected: " + this.selectDateText);
    }
    else if (this.selectedView === 'week') {
      //m.add(-7, 'days');
      startDate = m.clone().weekday(1);

      //console.log("week view selected: " + this.selectDateText);
    }
    this.setDateText(startDate);

    this._router.navigate([{ outlets: { schedule: [this.selectedView] } }], { relativeTo: this.route, queryParams: { selectedDate: m.format('yyyy-MM-DD') } });

  }

  loaded(mode: string) {
    if (mode === 'month' || mode === 'month-small') {
      this.selectDateText.set(this.selectedDate.format('MMMM'));
    }
    else if (mode === 'week') {
      this.selectDateText.set(this.selectedDate.format('yyyy-MM-DD'));
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  
}
